import AvatarContent from './AvatarContent';

export type Size = 'sm' | 'md';

export interface AvatarProps {
  variant: 'gradient' | 'normal';
  size: Size;
  src?: string;
}

const Avatar = ({ src, variant, size }: AvatarProps) => {
  const gradientId = `paint_${size}_${Math.random().toString(36).substr(2, 9)}`;

  return (
    <AvatarContent
      src={src}
      variant={variant}
      size={size}
      gradientId={gradientId}
    />
  );
};

export default Avatar;
